<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="headerTitle"
        [back]="true"
        [backRoute]="'/benefits/plans/' + benefitPlan.id + '/change-requests'"
    >
    </app-header>
    <div class="app-grid max-width">
        <div class="columns-8">
            <ui-card *ngIf="employeeDocument">
                <div class="file-wrapper">
                    <app-file-viewer [file]="employeeDocument.file" #fileViewer></app-file-viewer>
                </div>
            </ui-card>

            <ui-card *ngIf="changeRequest.status === 'pending'">
                <app-form-benefit-change-request-approval
                    [(changeRequest)]="changeRequest"
                ></app-form-benefit-change-request-approval>
                <div class="flex flex-end">
                    <ui-button type="ghost" (click)="onDecline()">{{
                        'benefits.views.changeRequest.deny' | appTranslate
                    }}</ui-button>
                    <ui-button type="primary" (click)="onApprove()">{{
                        'benefits.views.changeRequest.approve' | appTranslate
                    }}</ui-button>
                </div>
            </ui-card>
        </div>

        <ui-card class="columns-4">
            <h3>{{ 'change-requests.approvalFlow' | appTranslate }}</h3>
            <ui-approval-flow [approvalFlowSteps]="approvalFlowSteps"></ui-approval-flow>
        </ui-card>
    </div>
</div>
